import {
  FETCH_TOEGANGSCONTROLES,
  FETCH_TOEGANGSCONTROLE,
  SAVE_TOEGANGSCONTROLE,
  TOGGLE_TOEGANGSCONTROLE,
  TEST_TOEGANGSCONTROLE,
  START_AUTHORIZATION,
  REFRESH_TOKEN,
  TOEGANGSCONTROLE_ERROR
} from "./types";

const INITIAL_STATE = {
  toegangscontroles: [],
  currentToegangscontrole: null,
  loading: false,
  error: null,
  testResult: null,
  authorizationData: null
};

export default function toegangscontroleReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case FETCH_TOEGANGSCONTROLES:
      return {
        ...state,
        toegangscontroles: action.payload,
        loading: false,
        error: null
      };
      
    case FETCH_TOEGANGSCONTROLE:
      return {
        ...state,
        currentToegangscontrole: action.payload,
        loading: false,
        error: null
      };
      
    case SAVE_TOEGANGSCONTROLE:
      // Update bestaande of voeg nieuwe toe
      const updatedToegangscontroles = state.toegangscontroles.find(t => t._id === action.payload._id)
        ? state.toegangscontroles.map(t => t._id === action.payload._id ? action.payload : t)
        : [...state.toegangscontroles, action.payload];
        
      return {
        ...state,
        toegangscontroles: updatedToegangscontroles,
        currentToegangscontrole: action.payload,
        loading: false,
        error: null
      };
      
    case TOGGLE_TOEGANGSCONTROLE:
      return {
        ...state,
        toegangscontroles: state.toegangscontroles.map(t => 
          t._id === action.payload._id ? action.payload : t
        ),
        currentToegangscontrole: state.currentToegangscontrole?._id === action.payload._id 
          ? action.payload 
          : state.currentToegangscontrole,
        loading: false,
        error: null
      };
      
    case START_AUTHORIZATION:
      return {
        ...state,
        authorizationData: action.payload,
        loading: false,
        error: null
      };
      
    case REFRESH_TOKEN:
      // Update current config met nieuwe token info
      const refreshedConfig = state.currentToegangscontrole 
        ? { ...state.currentToegangscontrole, oauth_tokens: { ...state.currentToegangscontrole.oauth_tokens, ...action.payload } }
        : null;
        
      return {
        ...state,
        currentToegangscontrole: refreshedConfig,
        toegangscontroles: state.toegangscontroles.map(t => 
          t._id === refreshedConfig?._id ? refreshedConfig : t
        ),
        loading: false,
        error: null
      };
      
    case TEST_TOEGANGSCONTROLE:
      return {
        ...state,
        testResult: action.payload,
        loading: false,
        error: null
      };
      
    case TOEGANGSCONTROLE_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
        testResult: null,
        authorizationData: null
      };
      
    default:
      return state;
  }
}